import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import context from '@/main.js'
import { VueAxios } from './axios'
// import {
//   Modal,
//   notification
// } from 'ant-design-vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'

//自动设置后台服务 baseURL (也可以手工指定写死项目名字)
let baseDomain = window._CONFIG['domianURL']
let baseProject = baseDomain.substring(baseDomain.lastIndexOf('/'))

// 创建 axios 实例
const service = axios.create({
  baseURL: baseProject, // api base_url
  timeout: 900000 // 请求超时时间(TODO:原值9000)
})

const err = error => {
  if (error.response) {
    let data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)

    switch (error.response.status) {
      case 403:
        context.$notification.error({
          message: context.$i18n.t('disp.error'),
          description: context.$i18n.t('disp.accessRefuse'),
          duration: 4
        })
        break
      case 500:
        if (token == null || data.message == 'msg.invalidToken') {
          if (window.hasError500 == undefined || window.hasError500 == false) {
            window.hasError500 = true
            antd.Modal.error({
              title: context.$i18n.t('disp.error'),
              content: context.$i18n.t('msg.sessionTimeout'),
              okText: context.$i18n.t('disp.btn.confirm'),
              mask: true,
              onOk: () => {
                store.dispatch('Logout').then(() => {
                  Vue.ls.remove(ACCESS_TOKEN)
                  // window.location.reload()
                  // window.location.href = window.location.origin + '/user/login'
                  context.$router.push({
                    path: '/user'
                  })
                  window.hasError500 = false
                })
              }
            })
          }
        }
        break
      case 404:
        context.$notification.error({
          message: context.$i18n.t('disp.error'),
          description: context.$i18n.t('msg.error404'),
          duration: 4
        })
        break
      case 504:
        context.$notification.error({
          message: context.$i18n.t('disp.error'),
          description: context.$i18n.t('msg.timeout')
        })
        break
      case 401:
        context.$notification.error({
          message: context.$i18n.t('disp.error'),
          description: context.$i18n.t('msg.noAuth'),
          duration: 4
        })
        if (token) {
          store.dispatch('Logout').then(() => {
            setTimeout(() => {
              window.location.reload()
            }, 1500)
          })
        }
        break
      default:
        context.$notification.error({
          message: context.$i18n.t('disp.error'),
          description: data.message || '服务器可能正在重启中，请稍后再次尝试。',
          duration: 4
        })
        break
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(
  config => {
    const token = Vue.ls.get(ACCESS_TOKEN)
    const dds = Vue.ls.get('DDS')
    const locale = Vue.ls.get('Locale')
    const url = window.dataFilterUrl || document.body.attributes['data-url'] || location.pathname

    if (config.data) {
      trimObject(config.data)
    }

    if (token) {
      config.headers['X-Access-Token'] = token
      config.headers['DDS'] = dds
      config.headers['Locale'] = locale
      config.headers['Url'] = url
    }
    if (config.method == 'get') {
      if (config.url.indexOf('sys/dict/getDictItems') < 0) {
        config.params = {
          _t: Date.parse(new Date()) / 1000,
          ...config.params
        }
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(response => {
  if (response.data.success != undefined && response.data.success == false && response.data.message) {
    if (response.data.message == 'msg.repeatSubmit') {
      console.info('repeated submit has been passed')
      return response.data
    }

    if (response.data.message == 'disp.rules.duplicate') {
      console.info('duplicated item detected')
      return response.data
    }

    if (response.data.message == 'msg.logoutFail') {
      console.info('logout failed')
      return response.data
    }

    if (response.data.message.indexOf('org.springframework.validation.BeanPropertyBindingResult') >= 0) {
      console.info('org.springframework.validation.BeanPropertyBindingResult')
      return
    }

    if (
      document.querySelector('.a-modal-applyForm') &&
      document.querySelector('.a-modal-applyForm').__vue__ &&
      document.querySelector('.a-modal-applyForm').__vue__.$parent &&
      document.querySelector('.a-modal-applyForm').__vue__.$parent.loading
    ) {
      document.querySelector('.a-modal-applyForm').__vue__.$parent.loading = false
    }

    response.data.message.split(';').map((message, index) =>
      setTimeout(() => {
        message = message.replaceAll('msg.operation.fail', context.$i18n.t('msg.operation.fail'))

        context.$notification.error({
          message: context.$i18n.t('disp.error'),
          description: context.$i18n.t(message),
          duration: 10
        })
      }, index * 100)
    )
  } else {
    //setTimeout(() => {
    //  document.querySelectorAll('textarea').forEach(textarea => {
    //    autoTextarea(textarea)
    //  });
    //}, 500);
  }

  return response.data
}, err)

const installer = {
  vm: {},
  install(Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

export { installer as VueAxios, service as axios }

